// Utilities for displaying messages on the page, a la rails flash.
// All require views/shared/_javascript_flash.haml partial (or a copy) on page to handle these events.

export const flashAlert = message => {
  message = message || 'Something went wrong. Please try again.'
  const flashAlertEvent = new CustomEvent('flashAlert', { detail: { message: message } });
  window.dispatchEvent(flashAlertEvent);
}

export const flashNotice = message => {
  const flashNoticeEvent = new CustomEvent('flashNotice', { detail: { message: message } });
  window.dispatchEvent(flashNoticeEvent);
}

export const flashInfo = message => {
  message = message || 'Something went wrong. Please try again.'
  const flashInfoEvent = new CustomEvent('flashInfo', { detail: { message: message } });
  window.dispatchEvent(flashInfoEvent);
}

export const closeFlashInfo = () => {
  const closeFlashInfoEvent = new CustomEvent('closeFlashInfo');
  window.dispatchEvent(closeFlashInfoEvent);
}

export const closeFlashAlert = () => {
  const closeFlashAlertEvent = new CustomEvent('closeFlashAlert');
  window.dispatchEvent(closeFlashAlertEvent);
}

export const closeFlashNotice = () => {
  const closeFlashNoticeEvent = new CustomEvent('closeFlashNotice');
  window.dispatchEvent(closeFlashNoticeEvent);
}
